import { ApolloProvider } from '@apollo/client';
import { Leva } from 'leva';
import client from './lib/apollo';
import LandingPage from './pages/LandingPage';

const isDebug = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('debug');

export default function App() {
    return (
        <ApolloProvider client={client}>
            {/* Leva panel — only visible when ?debug is in the URL */}
            <Leva hidden={!isDebug} />
            <LandingPage />
        </ApolloProvider>
    );
}
